import React, { useRef, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import { postResendCode } from "../../../services/auth/registrationService";
import Input from "../../../components/forms/Input/Input";

export default function Confirm({
  onSubmit,
  error,
  loading,
  links,
  confirmText = "welcome.registration",
  username,
  purpose = 0, // 0: registration, 1: password reset
}) {
  const digitsRef = useRef([]);
  const [t] = useTranslation();

  const [resendCountdown, setResendCountdown] = useState(60);

  useEffect(() => {
    if (resendCountdown > 0) {
      setTimeout(() => {
        setResendCountdown(resendCountdown - 1);
      }, 1000);
    }
  }, [resendCountdown]);

  const { register, handleSubmit, setValue } = useForm();

  const array = [...Array(6)];

  return (
    <div className="pt-28 flex justify-center bg-slate-200 h-screen">
      <div className="flex flex-col gap-2 rounded-md border border-gray-300 bg-white p-8 h-fit">
        <form className="flex flex-col gap-2" onSubmit={handleSubmit(onSubmit)}>
          <p className="flex flex-col gap-1 break-normal w-[16rem] text-center">
            <span className="font-bold text-sm ">
              {t("signup.verification_code_sent_to_email")}
            </span>
            <span className="font-bold text-sm text-gray-500">
              {t("signup.enter_code")}
            </span>
          </p>

          <div className="flex flex-row gap-1">
            {array.map((digit, index) => (
              <Input
                key={index}
                maxLength="1"
                inputClassName={`bg-white shadow-none outline-1 !w-10 outline-gray-300 md:rounded-lg !px-0 text-center !pr-0 h-16 `}
                className="text-sm w-10"
                type="text"
                {...register(`code_${index}`, {
                  maxLength: 1,
                  required: true,
                })}
                onChange={(e) => {
                  if (e.target.value.length > 1) {
                    return;
                  }
                  register(`code_${index}`).onChange(e);
                  if (
                    e.target.value.length === 1 &&
                    digitsRef.current?.[index + 1]
                  ) {
                    digitsRef.current[index + 1].focus();
                  }
                }}
                ref={(el) => {
                  register(`code_${index}`).ref(el);
                  digitsRef.current[index] = el;
                }}
                onPaste={(e) => {
                  const text = e.clipboardData.getData("text");
                  if (text.length !== 6) {
                    return;
                  }
                  array.forEach((digit, index) => {
                    setValue(`code_${index}`, text?.[index]);
                  });
                  digitsRef.current[array.length - 1].focus();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Backspace") {
                    if (digitsRef.current[index].value === "" && index > 0) {
                      digitsRef.current[index - 1].focus();
                    }
                  }
                }}
              />
            ))}
          </div>

          <div className="rounded-lg overflow-hidden mt-2">
            <Button
              className="w-full text-base font-semibold"
              text={t(confirmText)}
              color="primary"
              type="submit"
              loading={loading}
              disabled={loading}
            />
          </div>
          <div
            className={`text-center text-primary underline-none  ${
              resendCountdown > 0
                ? "opacity-50 cursor-default"
                : "cursor-pointer"
            }`}
            onClick={() => {
              if (resendCountdown > 0) {
                return;
              }
              postResendCode({ username, purpose }).then(() => {
                setResendCountdown(60);
              });
            }}
          >
            {t("signup.resend_code")}{" "}
            {resendCountdown > 0 && `(${resendCountdown}c)`}
          </div>
        </form>
        {error && (
          <div className="text-red-500 mx-auto text-center">{error}</div>
        )}

        <div className="border-t border-gray-300"></div>

        {links.map((link) => (
          <div
            key={link.text}
            onClick={link.onClick}
            className="text-center text-primary underline-none cursor-pointer"
          >
            {link.text}
          </div>
        ))}
      </div>
    </div>
  );
}
